export const banners = {
  hummel: ['/images/banners/hummel_2.jpg'],
  icepeak: [
    // '/images/banners/icepeak_1.jpg',
    // '/images/banners/icepeak_2.jpg',
    // '/images/banners/icepeak_3.jpg',
    // '/images/banners/icepeak_4.jpg',
    // '/images/banners/icepeak_5.jpg',
    // '/images/banners/icepeak_6.jpg',
    '/images/banners/icepeak_7.jpg',
    '/images/banners/icepeak_8.jpg',
    '/images/banners/icepeak_9.jpg',
  ],
  luhta: [
    // '/images/banners/luhta_1.jpg',
    // '/images/banners/luhta_2.jpg',
    // '/images/banners/luhta_3.jpg',
    // '/images/banners/luhta_4.jpg',
    // '/images/banners/luhta_5.jpg',
    // '/images/banners/luhta_6.jpg',
    '/images/banners/luhta_7.jpg',
    '/images/banners/luhta_8.jpg',
    '/images/banners/luhta_9.jpg',
  ],
  rukka: [
    // '/images/banners/rukka_1.jpg',
    // '/images/banners/rukka_2.jpg',
    // '/images/banners/rukka_3.jpg',
    // '/images/banners/rukka_4.jpg',
    '/images/banners/rukka_5.jpg',
    '/images/banners/rukka_6.jpg',
  ],
  'cobra-puma-golf': ['/images/banners/cobra-puma-golf.jpg'],

  trilite: ['/images/banners/trilite_1.jpg'],

  dachstein: ['/images/banners/dachstein.jpg'],
  'elite-sport': ['/images/banners/elite_sport.jpg'],
}

